import { TabPanels, Tabs } from '@chakra-ui/react'
import React, { useEffect, useMemo, useState } from 'react'
import { Ringtone, useSettingsState } from '~/atoms/SettingsState'
import { useSharedVariable } from '~/hooks/useSharedVariable'
import { PopupHeader } from '~/pages/Popup/PopupHeader'
import { queueContainsCall } from '~/utils/popupQueueUtils'

import { PopupQueueItem, PopupQueueItemTypes } from '@mangovoice/types'

import { PopupItem } from './PopupItem'

export type QueueMeta = {
  messages: {
    count: number
  }
  calls: {
    count: number
  }
}

export const PopupPage = () => {
  const [activeTab, setActiveTab] = useState(0)

  const {
    settings: {
      webPhone: { ringtone },
    },
  } = useSettingsState()
  const [, setShowCallModal] = useSharedVariable<boolean>('ShowCallModal', true)
  const [messageQueue, _setMessageQueue] =
    useSharedVariable<PopupQueueItem[]>('MessageQueue')
  const [callQueue, _setCallQueue] =
    useSharedVariable<PopupQueueItem[]>('CallQueue')

  const shouldRing = ringtone !== Ringtone.SILENT

  // TODO: For testing
  // useEffect(() => {
  //   _setCallQueue([
  //     {
  //       callUuid: '31c9a0b3-11e0-4262-9a8a-d7e3beb201ed',
  //       isMuted: false,
  //       isOnHold: false,
  //       name: 'New Patient - FountainDentalCenter - MEYERS, MICHELLE',
  //       number: '+13852522002',
  //       startTime: null,
  //       status: 'INITIAL',
  //       type: 'call',
  //       _id: '31c9a0b3-11e0-4262-9a8a-d7e3beb201ed',
  //     } as PopupQueueItem,
  //   ])
  //   _setMessageQueue([
  //     {
  //       id: 1569491,
  //       message_group_id: 1747,
  //       name: 'Tyson P',
  //       external_phone_number: '+13852522002',
  //       unread_message_count: 3,
  //       latest_message: {
  //         id: 11994101,
  //         pbx_id: 4293,
  //         message_thread_id: 1569491,
  //         sender_user_id: undefined,
  //         direction: 'inbound',
  //         body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sagittis pharetra erat, in porta orci. Donec fringilla interdum arcu sed bibendum. Fusce hendrerit urna venenatis, lobortis arcu venenatis, convallis urna. Donec iaculis quam sapien, at luctus dui elementum vitae. Donec eget ullamcorper est. Suspendisse viverra gravida porttitor. Maecenas commodo est vel sapien dignissim, vel pharetra arcu convallis. Nam quis justo egestas, vulputate orci eu, vestibulum eros. Fusce porta maximus varius. Donec fringilla magna mauris, in auctor ligula euismod eu. Proin nec congue sem. Aenean finibus porttitor ligula, in consequat ex fringilla et. Curabitur dapibus, quam vel tincidunt elementum, ex metus finibus elit, vitae bibendum felis metus et lectus. Nulla molestie lacinia consequat. Vestibulum gravida venenatis libero vel mollis. Curabitur porttitor nibh eu dolor lacinia euismod.',
  //         files: [],
  //         created_at: '2025-02-23T23:04:04.000000Z',
  //         updated_at: '2025-02-23T23:04:04.000000Z',
  //       },
  //       created_at: '2025-02-17T17:31:13.000000Z',
  //       updated_at: '2025-02-23T23:04:04.000000Z',
  //       _id: '1569491',
  //       type: 'message',
  //     },
  //     {
  //       id: 1569491,
  //       message_group_id: 1747,
  //       name: 'Mango User',
  //       external_phone_number: '+13852522002',
  //       unread_message_count: 3,
  //       latest_message: {
  //         id: 11994101,
  //         pbx_id: 4293,
  //         message_thread_id: 1569491,
  //         sender_user_id: undefined,
  //         direction: 'inbound',
  //         body: 'This is a second test text message',
  //         files: [],
  //         created_at: '2025-02-23T23:04:04.000000Z',
  //         updated_at: '2025-02-23T23:04:04.000000Z',
  //       },
  //       created_at: '2025-02-17T17:31:13.000000Z',
  //       updated_at: '2025-02-23T23:04:04.000000Z',
  //       _id: '1569492',
  //       type: 'message',
  //     },
  //   ])
  // }, [])

  useEffect(() => {
    if (queueContainsCall(callQueue || [])) {
      setShowCallModal(false)
    }

    setActiveTab(callQueue?.length === 0 ? 1 : 0)
  }, [callQueue])

  const queueMeta: QueueMeta = useMemo(() => {
    return {
      messages: {
        count: messageQueue?.length || 0,
      },
      calls: {
        count: callQueue?.length || 0,
      },
    }
  }, [callQueue, messageQueue])

  const handleTabsChange = (index: number) => {
    setActiveTab(index)
  }

  return (
    <Tabs
      index={activeTab}
      onChange={handleTabsChange}
      size={'md'}
      variant={'soft-rounded'}
      display={'flex'}
      flexDirection="column"
      flex="1"
      padding={2}
      paddingY={2}
      height={'100%'}
    >
      <PopupHeader meta={queueMeta} />
      <TabPanels
        display={'flex'}
        flexDirection="column"
        height={'100%'}
        overflowY={'auto'}
      >
        {
          <PopupItem
            queueItems={callQueue || []}
            type={PopupQueueItemTypes.CALL}
            shouldRing={shouldRing}
          />
        }
        {
          <PopupItem
            queueItems={messageQueue || []}
            type={PopupQueueItemTypes.MESSAGE}
          />
        }
      </TabPanels>
    </Tabs>
  )
}
